/**
 * TODO:
 * - GET_USER_ROLES_ERROR
 * - SAVE_USER_ROLE_ERROR
 */
import * as action from './actionTypes';

export const getUserRoles = () => ({
    type: action.GET_USER_ROLES
})

export const getUserRolesSuccess = (roles) => ({
    type: action.GET_USER_ROLES_SUCCESS,
    payload: roles
})

export const saveUserRole = (role) => ({
    type: action.SAVE_USER_ROLE,
    payload: role
})

export const saveUserRoleSuccess = (role) => ({
    type: action.SAVE_USER_ROLE_SUCCESS,
    payload: role
})

// export const addGroupToRole = (role) => ({
//     type: action.ADD_GROUP_TO_ROLE,
//     payload: role
// })

// export const removeGroupFromRole = (groups) => ({
//     type: action.REMOVE_GROUP_FROM_ROLE,
//     payload: groups
// })

// export const discardRoleChanges = () => ({
//     type: action.DISCARD_ROLE_CHANGES
// })
